(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4433],{

/***/ 88480:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetArticlesPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allArticle_pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"EnumValue","value":"meta_firstPublicationDate_DESC"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_keywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"author_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"article_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"_meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstPublicationDate"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":414}};
    doc.loc.source = {"body":"query GetArticlesPageQuery($pageLang: String!) {\n  allArticle_pages(lang: $pageLang, sortBy: meta_firstPublicationDate_DESC) {\n    edges {\n      node {\n        seo_title\n        seo_description\n        seo_image\n        seo_keywords\n\n        title\n        author\n        author_image\n        article_image\n        _meta {\n          tags\n          firstPublicationDate\n        }\n        content\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetArticlesPageQuery = oneQuery(doc, "GetArticlesPageQuery");
        


/***/ }),

/***/ 4929:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetArticlesPageByTagQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tag"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allArticle_pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"EnumValue","value":"meta_firstPublicationDate_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"tags"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"tag"}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endCursor"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_keywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"article_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"author_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"_meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstPublicationDate"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":627}};
    doc.loc.source = {"body":"query GetArticlesPageByTagQuery(\n  $pageLang: String\n  $tag: String!\n  $cursor: String\n  $pageSize: Int\n) {\n  allArticle_pages(\n    lang: $pageLang\n    sortBy: meta_firstPublicationDate_DESC\n    after: $cursor\n    first: $pageSize\n    tags: [$tag]\n  ) {\n    totalCount\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    edges {\n      node {\n        seo_title\n        seo_description\n        seo_image\n        seo_url\n        seo_keywords\n\n        article_image\n        title\n        author\n        author_image\n        _meta {\n          tags\n          firstPublicationDate\n        }\n        content\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetArticlesPageByTagQuery = oneQuery(doc, "GetArticlesPageByTagQuery");
        


/***/ }),

/***/ 73848:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetArticlesPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allArticle_pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"EnumValue","value":"meta_firstPublicationDate_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endCursor"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_keywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"author_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"article_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"_meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstPublicationDate"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":591}};
    doc.loc.source = {"body":"query GetArticlesPageQuery(\n  $pageLang: String!\n  $cursor: String\n  $pageSize: Int!\n) {\n  allArticle_pages(\n    lang: $pageLang\n    sortBy: meta_firstPublicationDate_DESC\n    after: $cursor\n    first: $pageSize\n  ) {\n    totalCount\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    edges {\n      node {\n        seo_title\n        seo_description\n        seo_url\n        seo_keywords\n        seo_image\n\n        title\n        author\n        author_image\n        article_image\n        _meta {\n          tags\n          firstPublicationDate\n        }\n        content\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetArticlesPageQuery = oneQuery(doc, "GetArticlesPageQuery");
        


/***/ }),

/***/ 30172:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCarrerByNamePage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allCareer_pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seo_url_fulltext"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_keywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"back_button"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"apply_button_link"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_ExternalLink"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"apply_button_label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"position"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"salary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"salary_per_hour"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"working_hours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"working_hours_freelance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":571}};
    doc.loc.source = {"body":"query GetCarrerByNamePage($pageLang: String!, $url: String!) {\n  allCareer_pages(lang: $pageLang, where: { seo_url_fulltext: $url }) {\n    edges {\n      node {\n        seo_title\n        seo_description\n        seo_image\n        seo_url\n        seo_keywords\n\n        back_button\n        apply_button_link {\n          ... on _ExternalLink {\n            url\n          }\n        }\n        apply_button_label\n        position\n        salary\n        salary_per_hour\n        working_hours\n        working_hours_freelance\n        location\n        description\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetCarrerByNamePage = oneQuery(doc, "GetCarrerByNamePage");
        


/***/ }),

/***/ 67969:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCareerPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"careerLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allCareer_pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"careerLang"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_keywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"position"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"salary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"working_hours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":281}};
    doc.loc.source = {"body":"query GetCareerPage($careerLang: String!) {\n  allCareer_pages(lang: $careerLang) {\n    edges {\n      node {\n        seo_title\n        seo_description\n        seo_image\n        seo_keywords\n\n        position\n        salary\n        working_hours\n        location\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetCareerPage = oneQuery(doc, "GetCareerPage");
        


/***/ }),

/***/ 8411:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCareersPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"careerLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allCareers_pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_keywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title_tag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"play_video_button_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"join_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"join_text_secondary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"send_us_cv"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"send_us_cv_button"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"team_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"team_images_mobile"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_images_mobile_item"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"team_images"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_images_item"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"hr_team_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hr_team"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hr_person_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hr_person_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hr_person_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hr_person_bio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hr_person_mail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hr_person_phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hr_person_linkedin"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"recruitment_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recruitment_process"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recruitment_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recruitment_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recruitment_description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"welcome_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"welcome_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"welcome_main_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"welcome_images"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"welcome_image"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"benefits_title1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"benefits1"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"benefit_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"benefit_description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"sticker_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sticker_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sticker_action_label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sticker_action_link"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_ExternalLink"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meet_us"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meet_us_stages"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meet_us_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meet_us_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meet_us_image"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"openings_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"no_jobs_offers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"no_jobs_offers_email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"join_us_careers_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"join_us_careers_phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"join_us_careers_email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"join_us_careers_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"join_us"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Join_us"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"action_label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"action_link"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_ExternalLink"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"person_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"person_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"person_position"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"our_values"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Our_values"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"default_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"our_values"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"allCareer_pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"careerLang"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"position"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"salary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"working_hours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":2389}};
    doc.loc.source = {"body":"query GetCareersPage($pageLang: String!, $careerLang: String!) {\n  allCareers_pages(lang: $pageLang) {\n    edges {\n      node {\n        seo_title\n        seo_description\n        seo_image\n        seo_keywords\n        title\n        description\n        title_tag\n        play_video_button_text\n        join_text\n        join_text_secondary\n        send_us_cv\n        send_us_cv_button\n        team_image\n        team_images_mobile {\n          team_images_mobile_item\n        }\n        team_images {\n          team_images_item\n        }\n        hr_team_title\n        hr_team {\n          hr_person_image\n          hr_person_name\n          hr_person_title\n          hr_person_bio\n          hr_person_mail\n          hr_person_phone\n          hr_person_linkedin\n        }\n        recruitment_title\n        recruitment_process {\n          recruitment_image\n          recruitment_title\n          recruitment_description\n        }\n        welcome_title\n        welcome_description\n        welcome_main_image\n        welcome_images {\n          welcome_image\n        }\n        benefits_title1\n        benefits1 {\n          benefit_image\n          benefit_description\n        }\n        sticker_title\n        sticker_description\n        sticker_action_label\n        sticker_action_link {\n          ... on _ExternalLink {\n            url\n          }\n        }\n        meet_us\n        meet_us_stages {\n          meet_us_title\n          meet_us_description\n          meet_us_image\n        }\n        openings_title\n        no_jobs_offers\n        no_jobs_offers_email\n        join_us_careers_text\n        join_us_careers_phone\n        join_us_careers_email\n        join_us_careers_image\n        join_us {\n          ... on Join_us {\n            title\n            description\n            action_label\n            action_link {\n              ... on _ExternalLink {\n                url\n              }\n            }\n            person_image\n            person_name\n            person_position\n          }\n        }\n        our_values {\n          ... on Our_values {\n            title\n            default_description\n            our_values {\n              value\n              description\n            }\n          }\n        }\n      }\n    }\n  }\n  allCareer_pages(lang: $careerLang) {\n    edges {\n      node {\n        seo_url\n        position\n        salary\n        working_hours\n        location\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetCareersPage = oneQuery(doc, "GetCareersPage");
        


/***/ }),

/***/ 86315:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCaseStudyPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"casestudyLink"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allPagecase_studys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"casestudy_link_fulltext"},"value":{"kind":"Variable","name":{"kind":"Name","value":"casestudyLink"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_keywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"casestudy_link"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title_tag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"back_button"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"casestudy_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"casestudy_company"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_short_case_study"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additional_classname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"casestudy_image_parallax"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"casestudy_architecture_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"casestudy_architecture_content"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clientoverview_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clientoverview_content"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clientoverview_content_second"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clientoverview_numbers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overview_numbers_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overview_numbers_content"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"casestudy_problems"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"problems_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"problems_content"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"diagram_desktop_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"diagram_mobile_images"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diagram_image"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"diagram_tables"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Casestudy_diagram"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diagram_titles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diagram_title"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"first_table_dot"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"second_table_dot"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"third_table_dot"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"first_table_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"second_tablet_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"third_table_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"diagram_first_table"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_table_flag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"first_table_content"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"diagram_second_table"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"second_table_flag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"second_table_content"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"diagram_third_table"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"third_table_flag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"third_table_content"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quote_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"quote_content"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"quote_author"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"quote_author_position"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"quote_author_img"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"howWeMakeItWork_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"howWeMakeItWork_stages"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stage_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stage_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stage_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stage_page"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"next_case_study_text_1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"next_case_study_text_2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"next_case_study_link"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"next_case_study_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"short_case_project_overview_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"short_case_project_overview_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"short_case_project_overview_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"short_case_services_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"short_case_services_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"short_case_services_items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"short_case_services_item"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"short_case_technology_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"short_case_technology_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"short_case_technology_items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"short_case_technology_item"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"short_case_project_summary_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"short_case_project_summary_items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"short_case_project_summary_item_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"short_case_project_summary_item_description"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":2691}};
    doc.loc.source = {"body":"query GetCaseStudyPageQuery($pageLang: String!, $casestudyLink: String) {\n  allPagecase_studys(\n    where: { casestudy_link_fulltext: $casestudyLink }\n    lang: $pageLang\n  ) {\n    edges {\n      node {\n        seo_title\n        seo_description\n        seo_image\n        seo_keywords\n\n        casestudy_link\n        title_tag\n        back_button\n        casestudy_title\n        casestudy_company\n        is_short_case_study\n        additional_classname\n        casestudy_image_parallax\n        casestudy_architecture_title\n        casestudy_architecture_content\n        clientoverview_title\n        clientoverview_content\n        clientoverview_content_second\n        clientoverview_numbers {\n          overview_numbers_title\n          overview_numbers_content\n        }\n        casestudy_problems {\n          problems_title\n          problems_content\n        }\n        diagram_desktop_image\n        diagram_mobile_images {\n          diagram_image\n        }\n        diagram_tables {\n          ... on Casestudy_diagram {\n            diagram_titles {\n              diagram_title\n            }\n            first_table_dot\n            second_table_dot\n            third_table_dot\n            first_table_title\n            second_tablet_title\n            third_table_title\n            diagram_first_table {\n              first_table_flag\n              first_table_content\n            }\n            diagram_second_table {\n              second_table_flag\n              second_table_content\n            }\n            diagram_third_table {\n              third_table_flag\n              third_table_content\n            }\n          }\n        }\n        quote_title\n        quote_content\n        quote_author\n        quote_author_position\n        quote_author_img\n        howWeMakeItWork_title\n        howWeMakeItWork_stages {\n          stage_image\n          stage_title\n          stage_description\n          stage_page\n        }\n        next_case_study_text_1\n        next_case_study_text_2\n        next_case_study_link\n        next_case_study_image\n\n        short_case_project_overview_title\n        short_case_project_overview_description\n        short_case_project_overview_image\n        short_case_services_image\n        short_case_services_title\n        short_case_services_items {\n          short_case_services_item\n        }\n        short_case_technology_image\n        short_case_technology_title\n        short_case_technology_items {\n          short_case_technology_item\n        }\n        short_case_project_summary_image\n        short_case_project_summary_items {\n          short_case_project_summary_item_title\n          short_case_project_summary_item_description\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetCaseStudyPageQuery = oneQuery(doc, "GetCaseStudyPageQuery");
        


/***/ }),

/***/ 73675:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClientsPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allClients_pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_keywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"business_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"business_title2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"introduction_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"introduction_title2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reviews_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reviews_title2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reviews_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title_tag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clutch_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviewer_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reviewer_position"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reviewer_company"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reviewer_photo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"review_text"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"business_goals"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"business_goal"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"business_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"introduction_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"introduction_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"projects_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"projects_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project_summary"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"see_project"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"visible_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"services"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"service_label"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"highlights"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highlight_detail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"highlight_title"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"testimonial_quote"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"testimonial_author_picture"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"testimonial_author_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"testimonial_author_position"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"companies_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clients_companies"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company_logo"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"cooperation_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cooperation_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cooperation_description2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cooperation_contact_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cooperation_contact_link"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_ExternalLink"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":1634}};
    doc.loc.source = {"body":"query GetClientsPageQuery($pageLang: String!) {\n  allClients_pages(lang: $pageLang) {\n    edges {\n      node {\n        seo_title\n        seo_description\n        seo_image\n        seo_keywords\n\n        title\n        business_title\n        business_title2\n        introduction_title\n        introduction_title2\n        reviews_title\n        reviews_title2\n        reviews_description\n        title_tag\n        clutch_text\n        reviews {\n          reviewer_name\n          reviewer_position\n          reviewer_company\n          reviewer_photo\n          review_text\n        }\n        business_goals {\n          business_goal\n        }\n        business_image\n        introduction_text\n        introduction_image\n        projects_title\n        projects_description\n        projects {\n          project {\n            ... on Project_summary {\n              title\n              image\n              see_project\n              visible_title\n              services {\n                service_label\n              }\n              highlights {\n                highlight_detail\n                highlight_title\n              }\n              testimonial_quote\n              testimonial_author_picture\n              testimonial_author_name\n              testimonial_author_position\n            }\n          }\n        }\n        companies_title\n        clients_companies {\n          company_logo\n        }\n        cooperation_title\n        cooperation_description\n        cooperation_description2\n        cooperation_contact_text\n        cooperation_contact_link {\n          ... on _ExternalLink {\n            url\n          }\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetClientsPageQuery = oneQuery(doc, "GetClientsPageQuery");
        


/***/ }),

/***/ 11432:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCookiesComponentQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cookiesLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allCookiess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cookiesLang"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accept"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"learn_more"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":191}};
    doc.loc.source = {"body":"query GetCookiesComponentQuery($cookiesLang: String!) {\n  allCookiess(lang: $cookiesLang) {\n    edges {\n      node {\n        description\n        accept\n        learn_more\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetCookiesComponentQuery = oneQuery(doc, "GetCookiesComponentQuery");
        


/***/ }),

/***/ 28150:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductDesignPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allDevelopments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_keywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additional_nav"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"additional_nav_item_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additional_nav_item_link"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subtitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subtitle_info"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sub_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"development_process_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"development_process_subtitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"development_process_diagram"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"position"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"technologies_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tech_stack"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Our_tech_stack"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"icons"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"icon"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"development_process_subtitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title_tag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"our_approach"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approaches"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"projects_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project_summary"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"see_project"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"visible_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"services"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"service_label"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"highlights"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highlight_detail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"highlight_title"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"testimonial_quote"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"testimonial_author_picture"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"testimonial_author_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"testimonial_author_position"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"page_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"page_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"page_subtitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"page_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"help_you_with_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"back_button_label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_design_faq_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_design_faq_items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"answer"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"what_is_like_to_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"what_is_like_to_quote"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"what_is_like_to_person"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"what_is_like_to_person_position"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"join_us"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Join_us"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"action_label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"action_link"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_ExternalLink"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"person_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"person_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"person_position"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":2229}};
    doc.loc.source = {"body":"query GetProductDesignPage($pageLang: String!) {\n  allDevelopments(lang: $pageLang) {\n    edges {\n      node {\n        seo_title\n        seo_description\n        seo_image\n        seo_keywords\n\n        additional_nav {\n          additional_nav_item_name\n          additional_nav_item_link\n        }\n\n        sections {\n          title\n          subtitle\n          subtitle_info\n          description\n          sub_description\n          image\n        }\n\n        development_process_title\n        development_process_subtitle\n        development_process_diagram {\n          image\n          title\n          description\n          position\n        }\n        technologies_title\n        tech_stack {\n          ... on Our_tech_stack {\n            icons {\n              icon\n            }\n          }\n        }\n        development_process_subtitle\n\n        title_tag\n        our_approach\n        approaches {\n          title\n          description\n        }\n\n        projects_title\n        projects {\n          project {\n            ... on Project_summary {\n              title\n              image\n              see_project\n              visible_title\n              services {\n                service_label\n              }\n              highlights {\n                highlight_detail\n                highlight_title\n              }\n              testimonial_quote\n              testimonial_author_picture\n              testimonial_author_name\n              testimonial_author_position\n            }\n          }\n        }\n        page_title\n        page_name\n        page_subtitle\n        page_image\n        help_you_with_text\n        back_button_label\n        product_design_faq_title\n        product_design_faq_items {\n          question\n          answer\n        }\n        what_is_like_to_title\n        what_is_like_to_quote\n        what_is_like_to_person\n        what_is_like_to_person_position\n        join_us {\n          ... on Join_us {\n            title\n            description\n            action_label\n            action_link {\n              ... on _ExternalLink {\n                url\n              }\n            }\n            person_image\n            person_name\n            person_position\n          }\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetProductDesignPage = oneQuery(doc, "GetProductDesignPage");
        


/***/ }),

/***/ 9029:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductDesignPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allDiscoverys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_keywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title_tag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"page_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"page_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"page_subtitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"page_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"back_button_label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"help_you_with_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sections"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subtitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subtitle_info"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sub_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"whyyouneeddiscovery_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"whyyouneeddiscovery_title2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"whyyouneeddiscovery_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"whyyouneeddiscovery_steps"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"step_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"step_description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"discovery_process_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"discovery_process_subtitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"discovery_process_diagram"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"position"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"discovery_team_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"team_positions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"discovery_team_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"what_is_like_to_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"what_is_like_to_quote"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"what_is_like_to_author"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"what_is_like_to_person_position"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":1170}};
    doc.loc.source = {"body":"query GetProductDesignPage($pageLang: String!) {\n  allDiscoverys(lang: $pageLang) {\n    edges {\n      node {\n        seo_title\n        seo_description\n        seo_image\n        seo_keywords\n\n        title_tag\n        page_title\n        page_name\n        page_subtitle\n        page_image\n        back_button_label\n        help_you_with_text\n        sections {\n          title\n          subtitle\n          subtitle_info\n          description\n          sub_description\n          image\n        }\n\n        whyyouneeddiscovery_title\n        whyyouneeddiscovery_title2\n        whyyouneeddiscovery_description\n        whyyouneeddiscovery_steps {\n          step_title\n          step_description\n        }\n\n        discovery_process_title\n        discovery_process_subtitle\n        discovery_process_diagram {\n          description\n          title\n          image\n          position\n        }\n\n        discovery_team_title\n        team_positions {\n          position\n          description\n        }\n        discovery_team_image\n\n        what_is_like_to_title\n        what_is_like_to_quote\n        what_is_like_to_author\n        what_is_like_to_person_position\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetProductDesignPage = oneQuery(doc, "GetProductDesignPage");
        


/***/ }),

/***/ 88084:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEstimatePageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allEstimate_projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_keywords"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":217}};
    doc.loc.source = {"body":"query GetEstimatePageQuery($pageLang: String!) {\n  allEstimate_projects(lang: $pageLang) {\n    edges {\n      node {\n        seo_title\n        seo_description\n        seo_image\n        seo_keywords\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetEstimatePageQuery = oneQuery(doc, "GetEstimatePageQuery");
        


/***/ }),

/***/ 95300:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFooterComponentQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"footerLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allFooters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"footerLang"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company_contact_lines"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"link"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_ExternalLink"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"company_address_lines"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"page_link"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"page_url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_sub_page"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"direct_contact_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"legal_privacy_policy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"legal_copyright"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nda_checkbox"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contact_form_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contact_form_services"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact_form_checkboxes_input"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact_form_budget"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact_form_checkboxes_input"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"microsoft_partner_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contact_form_name"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact_form_text_input"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact_form_lastname"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact_form_text_input"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact_form_email"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact_form_text_input"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact_form_agreement"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact_form_text_input"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact_form_agreement"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact_form_checkbox"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact_form_project_details"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact_form_textarea_input"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact_form_file_attachment"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact_form_file_input"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact_form_submit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contact_form_success_icon"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contact_form_success_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contact_form_success_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contact_form_success_button"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contact_form_error_icon"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contact_form_error_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contact_form_error_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contact_form_error_button"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":2813}};
    doc.loc.source = {"body":"query GetFooterComponentQuery($footerLang: String!) {\n  allFooters(lang: $footerLang) {\n    edges {\n      node {\n        company_contact_lines {\n          label\n          link {\n            ... on _ExternalLink {\n              url\n            }\n          }\n          image\n        }\n        company_address_lines {\n          label\n        }\n        page_link {\n          name\n          page_url\n          is_sub_page\n        }\n        direct_contact_title\n        legal_privacy_policy\n        legal_copyright\n        nda_checkbox\n        contact_form_title\n        contact_form_services {\n          ... on Contact_form_checkboxes_input {\n            title\n            options {\n              label\n              value\n            }\n            errors {\n              name\n              message\n            }\n          }\n        }\n        contact_form_budget {\n          ... on Contact_form_checkboxes_input {\n            title\n            options {\n              label\n              value\n            }\n            errors {\n              name\n              message\n            }\n          }\n        }\n        microsoft_partner_image\n        contact_form_name {\n          ... on Contact_form_text_input {\n            label\n            errors {\n              name\n              message\n            }\n          }\n        }\n        contact_form_lastname {\n          ... on Contact_form_text_input {\n            label\n            errors {\n              name\n              message\n            }\n          }\n        }\n        contact_form_email {\n          ... on Contact_form_text_input {\n            label\n            errors {\n              name\n              message\n            }\n          }\n        }\n        contact_form_agreement {\n          ... on Contact_form_text_input {\n            label\n            errors {\n              name\n              message\n            }\n          }\n        }\n        contact_form_agreement {\n          ... on Contact_form_checkbox {\n            label\n            errors {\n              name\n              message\n            }\n          }\n        }\n        contact_form_project_details {\n          ... on Contact_form_textarea_input {\n            label\n            errors {\n              name\n              message\n            }\n          }\n        }\n        contact_form_file_attachment {\n          ... on Contact_form_file_input {\n            label\n            errors {\n              name\n              message\n            }\n          }\n        }\n        contact_form_submit\n        contact_form_success_icon\n        contact_form_success_title\n        contact_form_success_description\n        contact_form_success_button\n        contact_form_error_icon\n        contact_form_error_title\n        contact_form_error_description\n        contact_form_error_button\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetFooterComponentQuery = oneQuery(doc, "GetFooterComponentQuery");
        


/***/ }),

/***/ 59489:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetHeaderComponentQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"headerLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allHeaders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"headerLang"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link_clients"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"link_services"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"link_about_us"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"link_insights"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"link_careers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"link_cta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"services_sublinks"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"nav_description"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":351}};
    doc.loc.source = {"body":"query GetHeaderComponentQuery($headerLang: String!) {\n  allHeaders(lang: $headerLang) {\n    edges {\n      node {\n        link_clients\n        link_services\n        link_about_us\n        link_insights\n        link_careers\n        link_cta\n        services_sublinks {\n          link\n          label\n        }\n        nav_description\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetHeaderComponentQuery = oneQuery(doc, "GetHeaderComponentQuery");
        


/***/ }),

/***/ 28376:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getHomePageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allHome_pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_keywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showreel_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showreel_subtitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showreel_cursor_caption"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contact_us"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact_us"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"action_link"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_ExternalLink"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"showreel_features"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gradient_text"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"whoWeAre_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"whoWeAre_highlightedDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"whoWeAre_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"whoWeAre_descriptionSecondary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"whoWeAre_button"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"projects_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"projects_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project_summary"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"see_project"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"visible_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"services"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"service_label"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"highlights"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highlight_detail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"highlight_title"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"testimonial_quote"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"testimonial_author_picture"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"testimonial_author_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"testimonial_author_position"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"faq_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"faq_items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"answer"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"howWeMakeItWork_companiesTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"howWeMakeItWork_companies"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company_logo"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"coverWithInfo_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coverWithInfo_backgroundImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coverWithInfo_contactButton"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contact_us"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action_label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"action_link"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_ExternalLink"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":1807}};
    doc.loc.source = {"body":"query getHomePageQuery($pageLang: String!) {\n  allHome_pages(lang: $pageLang) {\n    edges {\n      node {\n        seo_title\n        seo_description\n        seo_image\n        seo_keywords\n\n        showreel_title\n        showreel_subtitle\n        showreel_cursor_caption\n        contact_us {\n          ... on Contact_us {\n            action_label\n            action_link {\n              ... on _ExternalLink {\n                url\n              }\n            }\n          }\n        }\n        showreel_features {\n          text\n          gradient_text\n        }\n        whoWeAre_title\n        whoWeAre_highlightedDescription\n        whoWeAre_description\n        whoWeAre_descriptionSecondary\n        whoWeAre_button\n        projects_title\n        projects_description\n        projects {\n          project {\n            ... on Project_summary {\n              title\n              image\n              see_project\n              visible_title\n              services {\n                service_label\n              }\n              highlights {\n                highlight_detail\n                highlight_title\n              }\n              testimonial_quote\n              testimonial_author_picture\n              testimonial_author_name\n              testimonial_author_position\n            }\n          }\n        }\n        faq_title\n        faq_items {\n          question\n          answer\n        }\n\n        howWeMakeItWork_companiesTitle\n        howWeMakeItWork_companies {\n          company_logo\n        }\n        coverWithInfo_title\n        coverWithInfo_backgroundImage\n        coverWithInfo_contactButton {\n          ... on Contact_us {\n            action_label\n            action_link {\n              ... on _ExternalLink {\n                url\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.getHomePageQuery = oneQuery(doc, "getHomePageQuery");
        


/***/ }),

/***/ 7610:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetArticleNextPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allArticle_pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstPublicationDate_after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"EnumValue","value":"meta_firstPublicationDate_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"author_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"_meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstPublicationDate"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"article_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_url"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":417}};
    doc.loc.source = {"body":"query GetArticleNextPageQuery($pageLang: String!, $cursor: DateTime) {\n  allArticle_pages(\n    lang: $pageLang\n    firstPublicationDate_after: $cursor\n    sortBy: meta_firstPublicationDate_ASC\n    first: 1\n  ) {\n    edges {\n      node {\n        title\n        author\n        author_image\n        _meta {\n          tags\n          firstPublicationDate\n        }\n        article_image\n        seo_url\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetArticleNextPageQuery = oneQuery(doc, "GetArticleNextPageQuery");
        


/***/ }),

/***/ 39277:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetArticlePageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allArticle_pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seo_url_fulltext"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_keywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"article_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"author_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"_meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstPublicationDate"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":451}};
    doc.loc.source = {"body":"query GetArticlePageQuery($pageLang: String!, $url: String) {\n  allArticle_pages(lang: $pageLang, where: { seo_url_fulltext: $url }) {\n    edges {\n      node {\n        seo_title\n        seo_description\n        seo_url\n        seo_keywords\n        seo_image\n\n        article_image\n        title\n        author\n        author_image\n        _meta {\n          tags\n          firstPublicationDate\n        }\n        content\n      }\n      cursor\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetArticlePageQuery = oneQuery(doc, "GetArticlePageQuery");
        


/***/ }),

/***/ 49046:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInsightsPage"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allInsights_pages"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_keywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"back_button"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"article"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"read_more_button"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"see_next"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"top_insights"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paths"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"display_all"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"next"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previous"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":380}};
    doc.loc.source = {"body":"query GetInsightsPage {\n  allInsights_pages {\n    edges {\n      node {\n        seo_title\n        seo_description\n        seo_image\n        seo_keywords\n\n        title\n        back_button\n        article\n        read_more_button\n        see_next\n        top_insights\n        paths {\n          label\n          display_all\n        }\n        next\n        previous\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetInsightsPage = oneQuery(doc, "GetInsightsPage");
        


/***/ }),

/***/ 80868:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInternalServerErrorPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allInternal_server_error_pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":206}};
    doc.loc.source = {"body":"query getInternalServerErrorPageQuery($pageLang: String!) {\n  allInternal_server_error_pages(lang: $pageLang) {\n    edges {\n      node {\n        title\n        description\n        action\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.getInternalServerErrorPageQuery = oneQuery(doc, "getInternalServerErrorPageQuery");
        


/***/ }),

/***/ 36201:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNewsletterComponentQuery"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allComponent_newsletters"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"about_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"about_text2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"button_label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"agreement_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"agreement_text2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"privacy_policy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"info_button_img"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"button_confirmation_label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"modal_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"modal_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"modal_text_second"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email_label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstname_label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"errors_firstname"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"errors_agreement"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":621}};
    doc.loc.source = {"body":"query GetNewsletterComponentQuery {\n  allComponent_newsletters {\n    edges {\n      node {\n        title\n        about_text\n        about_text2\n        button_label\n        agreement_text\n        agreement_text2\n        privacy_policy\n        info_button_img\n        button_confirmation_label\n        modal_title\n        modal_text\n        modal_text_second\n        email_label\n        firstname_label\n        errors {\n          name\n          message\n        }\n        errors_firstname {\n          name\n          message\n        }\n        errors_agreement {\n          name\n          message\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetNewsletterComponentQuery = oneQuery(doc, "GetNewsletterComponentQuery");
        


/***/ }),

/***/ 62383:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNotFoundPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allNot_found_pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":163}};
    doc.loc.source = {"body":"query GetNotFoundPageQuery($pageLang: String!) {\n  allNot_found_pages(lang: $pageLang) {\n    edges {\n      node {\n        title\n        action\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetNotFoundPageQuery = oneQuery(doc, "GetNotFoundPageQuery");
        


/***/ }),

/***/ 12860:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPrivacyPolicyPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allDocument_pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tags"},"value":{"kind":"StringValue","value":"privacy-policy","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_keywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"content"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"last_update"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"last_update_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"_linkType"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":338}};
    doc.loc.source = {"body":"query getPrivacyPolicyPageQuery($pageLang: String!) {\n  allDocument_pages(tags: \"privacy-policy\", lang: $pageLang) {\n    edges {\n      node {\n        seo_title\n        seo_description\n        seo_image\n        seo_keywords\n\n        title\n        content\n        last_update\n        last_update_title\n        _linkType\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.getPrivacyPolicyPageQuery = oneQuery(doc, "getPrivacyPolicyPageQuery");
        


/***/ }),

/***/ 30363:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductDesignPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allPage_product_designs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_keywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title_tag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additional_nav"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"additional_nav_item_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additional_nav_item_link"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"design_process_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"design_process_subtitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"design_process_diagram"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"position"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subtitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sub_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subtitle_info"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"process_timeline_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"projects_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"projects_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Project_summary"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"see_project"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"visible_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"services"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"service_label"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"highlights"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highlight_detail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"highlight_title"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"testimonial_quote"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"testimonial_author_picture"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"testimonial_author_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"testimonial_author_position"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"page_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"page_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"page_subtitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"page_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"help_you_with_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"back_button_label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"live_collaboration_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"live_collaboration_text1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"live_collaboration_text2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"what_we_have_built_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"what_we_have_built_image_desktop"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"what_we_have_built_image_tablet"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"what_we_have_built_image_mobile"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"what_we_have_built_mobile"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"what_we_have_built_image"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"want_to_see_more_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dribbble_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"behance_text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dribbble"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"behance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_design_faq_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_design_faq_items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"answer"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"what_is_like_to_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"what_is_like_to_quote"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"what_is_like_to_person"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"what_is_like_to_person_position"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"join_us"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Join_us"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"action_label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"action_link"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_ExternalLink"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"person_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"person_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"person_position"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":2436}};
    doc.loc.source = {"body":"query GetProductDesignPage($pageLang: String!) {\n  allPage_product_designs(lang: $pageLang) {\n    edges {\n      node {\n        seo_title\n        seo_description\n        seo_image\n        seo_keywords\n\n        title_tag\n        additional_nav {\n          additional_nav_item_name\n          additional_nav_item_link\n        }\n        design_process_title\n        design_process_subtitle\n        design_process_diagram {\n          title\n          description\n          image\n          position\n        }\n\n        sections {\n          title\n          subtitle\n          description\n          sub_description\n          image\n          subtitle_info\n        }\n        process_timeline_image\n        projects_title\n        projects_description\n        projects {\n          project {\n            ... on Project_summary {\n              title\n              image\n              see_project\n              visible_title\n              services {\n                service_label\n              }\n              highlights {\n                highlight_detail\n                highlight_title\n              }\n              testimonial_quote\n              testimonial_author_picture\n              testimonial_author_name\n              testimonial_author_position\n            }\n          }\n        }\n\n        page_title\n        page_name\n        page_subtitle\n        page_image\n        help_you_with_text\n        back_button_label\n        live_collaboration_title\n        live_collaboration_text1\n        live_collaboration_text2\n        what_we_have_built_title\n        what_we_have_built_image_desktop\n        what_we_have_built_image_tablet\n        what_we_have_built_image_mobile\n        what_we_have_built_mobile {\n          what_we_have_built_image\n        }\n        want_to_see_more_text\n        dribbble_text\n        behance_text\n        dribbble\n        behance\n        product_design_faq_title\n        product_design_faq_items {\n          question\n          answer\n        }\n        what_is_like_to_title\n        what_is_like_to_quote\n        what_is_like_to_person\n        what_is_like_to_person_position\n        join_us {\n          ... on Join_us {\n            title\n            description\n            action_label\n            action_link {\n              ... on _ExternalLink {\n                url\n              }\n            }\n            person_image\n            person_name\n            person_position\n          }\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetProductDesignPage = oneQuery(doc, "GetProductDesignPage");
        


/***/ }),

/***/ 60233:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRecruitmentPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recruitmentLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allRecruitment_processs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recruitmentLang"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stages"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stage_icon"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stage_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stage_description"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":263}};
    doc.loc.source = {"body":"query GetRecruitmentPage($recruitmentLang: String!) {\n  allRecruitment_processs(lang: $recruitmentLang) {\n    edges {\n      node {\n        title\n        stages {\n          stage_icon\n          stage_title\n          stage_description\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetRecruitmentPage = oneQuery(doc, "GetRecruitmentPage");
        


/***/ }),

/***/ 57945:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSeoQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seoLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allSeos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seoLang"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_keywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_image"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":193}};
    doc.loc.source = {"body":"query GetSeoQuery($seoLang: String!) {\n  allSeos(lang: $seoLang) {\n    edges {\n      node {\n        seo_title\n        seo_description\n        seo_keywords\n        seo_image\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetSeoQuery = oneQuery(doc, "GetSeoQuery");
        


/***/ }),

/***/ 8510:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetServicesPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allServices_pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seo_keywords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title_tag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"introduction"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"services"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"content"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"service_link"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"service_list"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"animation_link"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_ExternalLink"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"our_tech_stack"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Our_tech_stack"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"icons"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"icon"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"what_we_can_do_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"what_we_can_do_list"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"icon"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"icon_description"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"partner_team"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Extend_your_team"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subtitle"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"why_us_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"why_us_reasons"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reason_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reason_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reason_description"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":1098}};
    doc.loc.source = {"body":"query GetServicesPage($pageLang: String!) {\n  allServices_pages(lang: $pageLang) {\n    edges {\n      node {\n        seo_title\n        seo_description\n        seo_image\n        seo_keywords\n\n        title_tag\n        title\n        introduction\n        description\n        services {\n          title\n          content\n          service_link\n          service_list\n          animation_link {\n            ... on _ExternalLink {\n              url\n            }\n          }\n        }\n        our_tech_stack {\n          ... on Our_tech_stack {\n            title\n            description\n            icons {\n              icon\n            }\n            what_we_can_do_title\n            what_we_can_do_list {\n              icon\n              icon_description\n            }\n          }\n        }\n        partner_team {\n          ... on Extend_your_team {\n            title\n            description\n            image\n            subtitle\n          }\n        }\n        why_us_title\n        why_us_reasons {\n          reason_title\n          reason_image\n          reason_description\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.GetServicesPage = oneQuery(doc, "GetServicesPage");
        


/***/ }),

/***/ 49867:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSummarizedArticleOpenings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allArticle_pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"_meta"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstPublicationDate"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":228}};
    doc.loc.source = {"body":"query getSummarizedArticleOpenings($pageLang: String!) {\n  allArticle_pages(lang: $pageLang) {\n    edges {\n      node {\n        seo_url\n        _meta {\n          tags\n          firstPublicationDate\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.getSummarizedArticleOpenings = oneQuery(doc, "getSummarizedArticleOpenings");
        


/***/ }),

/***/ 46965:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSummarizedJobOpenings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allCareer_pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"position"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"working_hours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":207}};
    doc.loc.source = {"body":"query getSummarizedJobOpenings($pageLang: String!) {\n  allCareer_pages(lang: $pageLang) {\n    edges {\n      node {\n        seo_url\n        position\n        working_hours\n        location\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.getSummarizedJobOpenings = oneQuery(doc, "getSummarizedJobOpenings");
        


/***/ }),

/***/ 78121:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getArticlesTopQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allArticle_pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageLang"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"top_article"},"value":{"kind":"BooleanValue","value":true}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo_url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"article_image"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":228}};
    doc.loc.source = {"body":"query getArticlesTopQuery($pageLang: String!) {\n  allArticle_pages(lang: $pageLang, where: { top_article: true }) {\n    edges {\n      node {\n        seo_url\n        title\n        author\n        article_image\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.getArticlesTopQuery = oneQuery(doc, "getArticlesTopQuery");
        


/***/ }),

/***/ 96540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F$": function() { return /* reexport default from dynamic */ _footer_component_graphql__WEBPACK_IMPORTED_MODULE_0___default.a; },
/* harmony export */   "Pt": function() { return /* reexport default from dynamic */ _summarized_job_openings_graphql__WEBPACK_IMPORTED_MODULE_22___default.a; },
/* harmony export */   "g2": function() { return /* reexport default from dynamic */ _seo_graphql__WEBPACK_IMPORTED_MODULE_23___default.a; },
/* harmony export */   "iK": function() { return /* reexport default from dynamic */ _articles_page_graphql__WEBPACK_IMPORTED_MODULE_4___default.a; },
/* harmony export */   "o2": function() { return /* reexport default from dynamic */ _header_component_graphql__WEBPACK_IMPORTED_MODULE_1___default.a; },
/* harmony export */   "p3": function() { return /* reexport default from dynamic */ _articles_by_tag_page_graphql__WEBPACK_IMPORTED_MODULE_5___default.a; },
/* harmony export */   "tT": function() { return /* reexport default from dynamic */ _summarized_article_openings_graphql__WEBPACK_IMPORTED_MODULE_20___default.a; },
/* harmony export */   "z_": function() { return /* reexport default from dynamic */ _cookies_component_graphql__WEBPACK_IMPORTED_MODULE_2___default.a; }
/* harmony export */ });
/* harmony import */ var _footer_component_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95300);
/* harmony import */ var _footer_component_graphql__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_footer_component_graphql__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _header_component_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59489);
/* harmony import */ var _header_component_graphql__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_header_component_graphql__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _cookies_component_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11432);
/* harmony import */ var _cookies_component_graphql__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_cookies_component_graphql__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _top_articles_component_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78121);
/* harmony import */ var _top_articles_component_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_top_articles_component_graphql__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _articles_page_graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73848);
/* harmony import */ var _articles_page_graphql__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_articles_page_graphql__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _articles_by_tag_page_graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4929);
/* harmony import */ var _articles_by_tag_page_graphql__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_articles_by_tag_page_graphql__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _all_articles_graphql__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88480);
/* harmony import */ var _all_articles_graphql__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_all_articles_graphql__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _insights_page_graphql__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49046);
/* harmony import */ var _insights_page_graphql__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_insights_page_graphql__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _career_page_graphql__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67969);
/* harmony import */ var _career_page_graphql__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_career_page_graphql__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _career_by_name_page_graphql__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30172);
/* harmony import */ var _career_by_name_page_graphql__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_career_by_name_page_graphql__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _careers_page_graphql__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8411);
/* harmony import */ var _careers_page_graphql__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_careers_page_graphql__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _recruitment_page_graphql__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(60233);
/* harmony import */ var _recruitment_page_graphql__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_recruitment_page_graphql__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _not_found_page_graphql__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(62383);
/* harmony import */ var _not_found_page_graphql__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_not_found_page_graphql__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _services_page_graphql__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8510);
/* harmony import */ var _services_page_graphql__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_services_page_graphql__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _case_study_page_graphql__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86315);
/* harmony import */ var _case_study_page_graphql__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_case_study_page_graphql__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _clients_page_graphql__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(73675);
/* harmony import */ var _clients_page_graphql__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_clients_page_graphql__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _home_page_graphql__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(28376);
/* harmony import */ var _home_page_graphql__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_home_page_graphql__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _insight_next_page_graphql__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(7610);
/* harmony import */ var _insight_next_page_graphql__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_insight_next_page_graphql__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _insight_page_graphql__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(39277);
/* harmony import */ var _insight_page_graphql__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_insight_page_graphql__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _internal_server_error_page_graphql__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(80868);
/* harmony import */ var _internal_server_error_page_graphql__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_internal_server_error_page_graphql__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _summarized_article_openings_graphql__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(49867);
/* harmony import */ var _summarized_article_openings_graphql__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_summarized_article_openings_graphql__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _privacy_policy_page_graphql__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(12860);
/* harmony import */ var _privacy_policy_page_graphql__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_privacy_policy_page_graphql__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _summarized_job_openings_graphql__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(46965);
/* harmony import */ var _summarized_job_openings_graphql__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_summarized_job_openings_graphql__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _seo_graphql__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(57945);
/* harmony import */ var _seo_graphql__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_seo_graphql__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _newsletter_graphql__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(36201);
/* harmony import */ var _newsletter_graphql__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_newsletter_graphql__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _product_design_graphql__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(30363);
/* harmony import */ var _product_design_graphql__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_product_design_graphql__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _development_graphql__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(28150);
/* harmony import */ var _development_graphql__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_development_graphql__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _discovery_graphql__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(9029);
/* harmony import */ var _discovery_graphql__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_discovery_graphql__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _estimate_project_page_graphql__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(88084);
/* harmony import */ var _estimate_project_page_graphql__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_estimate_project_page_graphql__WEBPACK_IMPORTED_MODULE_28__);































/***/ }),

/***/ 94433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l8": function() { return /* binding */ apolloClient; },
/* harmony export */   "pm": function() { return /* binding */ getQuery; },
/* harmony export */   "uH": function() { return /* binding */ getPageQuery; }
/* harmony export */ });
/* unused harmony export defaultQueryResult */
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33814);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10547);
/* harmony import */ var apollo_link_prismic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14909);
/* harmony import */ var graphql_combine_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4575);
/* harmony import */ var graphql_combine_query__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_combine_query__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _graphql_queries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96540);




const apolloClient = new _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .ApolloClient */ .f({
    link: (0,apollo_link_prismic__WEBPACK_IMPORTED_MODULE_3__/* .createPrismicLink */ .s)({
        repositoryName: "qodeca-website",
        accessToken: "MC5ZSUxJeXhBQUFDUUFHUWE2.Wu-_vRoB77-9Iu-_ve-_vTQlQVww77-977-9He-_vT3vv73vv70277-9fO-_ve-_vTcN77-9EO-_vVnvv70"
    }),
    cache: new _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* .InMemoryCache */ .h()
});
const defaultQueryResult = (param)=>{
    let { allHeaders , allFooters , allCookiess  } = param;
    return {
        header: allHeaders.edges[0].node,
        footer: allFooters.edges[0].node,
        cookies: allCookiess.edges[0].node
    };
};
const getPageQuery = (variables, queryName, pageQuery)=>{
    const combine = graphql_combine_query__WEBPACK_IMPORTED_MODULE_0___default()(queryName);
    let query = combine.add(_graphql_queries__WEBPACK_IMPORTED_MODULE_1__/* .HEADER_QUERY */ .o2, {
        headerLang: variables.pageLang
    }).add(_graphql_queries__WEBPACK_IMPORTED_MODULE_1__/* .FOOTER_QUERY */ .F$, {
        footerLang: variables.pageLang
    }).add(_graphql_queries__WEBPACK_IMPORTED_MODULE_1__/* .COOKIES_QUERY */ .z_, {
        cookiesLang: variables.pageLang
    }).add(_graphql_queries__WEBPACK_IMPORTED_MODULE_1__/* .SEO_QUERY */ .g2, {
        seoLang: variables.pageLang
    });
    if (!pageQuery) {
        return {
            query: query.document,
            variables: query.variables
        };
    }
    if (Array.isArray(pageQuery)) {
        pageQuery.filter((x)=>x).forEach((currentQuery)=>{
            query = query.add(currentQuery, variables);
        });
    } else {
        query = query.add(pageQuery, variables);
    }
    return {
        query: query.document,
        variables: query.variables
    };
};
const getQuery = (variables, queryName, pageQuery)=>{
    const combine = graphql_combine_query__WEBPACK_IMPORTED_MODULE_0___default()(queryName);
    let query = null;
    if (Array.isArray(pageQuery)) {
        pageQuery.filter((x)=>x).forEach((currentQuery)=>{
            query = query ? query.add(currentQuery, variables) : combine.add(currentQuery, variables);
        });
        return {
            query: query.document,
            variables: query.variables
        };
    } else {
        query = combine.add(pageQuery, variables);
        return {
            query: query.document,
            variables: query.variables
        };
    }
};


/***/ })

}]);